import { ISorter } from "@/models/tables";
import i18n from "@/i18n";

const creditNotesSorters: ISorter[] = [
  {
    field: "number",
    label: i18n.t("_.credit_note_id").toString()
  },
  {
    field: "total_amount",
    label: i18n.t("_.amount").toString()
  },
  {
    field: "status",
    label: i18n.t("_.status").toString()
  },
  {
    field: "create_datetime",
    label: i18n.t("_.date_created").toString()
  }
];

export default creditNotesSorters;
